// extracted by mini-css-extract-plugin
module.exports = {"btnGroup":"CockpitNotLoggedTopContainer_btnGroup__2oBXE","offersButton":"CockpitNotLoggedTopContainer_offersButton__1hTEL"};